import { MarketingShell } from "@/components/landing/MarketingShell";
import { ListTemplates } from "@/components/launch/ListTemplates";
import { SeoHead } from "@/components/useSeo";
import logger from "@/lib/logger";
import { getTemplates } from "@/lib/templates";
import { getCurrentUser } from "@/lib/user";
import { bool } from "@/lib/utils";
import { User } from "@/types";
import { Template } from "@/types/template";
import { GetServerSideProps } from "next";
import { getServerSession } from "@/lib/middleware";

export default function Page({ templates }: { templates: Template[] }) {
  return (
    <MarketingShell>
      <SeoHead path="r" />
      <ListTemplates templates={templates} />
    </MarketingShell>
  );
}

export const getServerSideProps: GetServerSideProps = async context => {
  let user: Pick<User, "id" | "tenantId"> | undefined;
  const session = await getServerSession(
    {
      ...context.req,
      query: context.query
    },
    context.res
  );

  if (session?.user) {
    user = (await getCurrentUser(session.user.id, session.user.tenantId)) ?? undefined;
    if (!user) {
      logger.warn("User not found", session.user.id);
    }
  }

  const templates = await getTemplates(user, bool(context.query.skipCache));

  return {
    props: {
      templates
    }
  };
};
